import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import main, { AppLocalKey } from '../../main';
import { AppStore } from '../../types';

const itemWidth = 34;
const itemHeight = 114;
const space = 10;
export default function FloatCustomer() {
  const divRef = useRef<any>();

  const config = useSelector((state: AppStore) => state.systemConfig);

  const [left, setLeft] = useState<number>(window.innerWidth - itemWidth - space); // 向左移动的距离
  const [top, setTop] = useState<number>(window.innerHeight - itemHeight - 300); // 向上移动的距离

  useEffect(() => {
    if (main.customerPositionWrite) {
      setLeft(main.customerLeft);
      setTop(main.customerTop);
      main.customerPositionWrite = false;
    }
  }, []);

  useEffect(() => {
    main.customerPositionWrite = true;
    main.customerLeft = left;
    main.customerTop = top;
  }, [left, top]);

  function handleClick(e: any) {
    e.stopPropagation();
    e.preventDefault();
    let customerUrl = config.results?.find((i) => i.configKey === AppLocalKey.customerH5);
    if (customerUrl) {
      window.open(customerUrl.configValue);
    }
  }

  //开始拖拽
  function handleDragStart() {
    divRef!.current!.style.transition = 'none';
    document.body.style.overflow = 'hidden';
  }
  //触摸移动
  function handleTouchMove(e: React.TouchEvent<HTMLDivElement>) {
    if (e.targetTouches.length === 1) {
      let touch = e.targetTouches[0];
      let left = touch.clientX - itemWidth / 2;
      let top = touch.clientY - itemHeight / 2;
      if (left < space) {
        left = space;
      }
      if (left > window.innerWidth - itemWidth - space) {
        left = window.innerWidth - itemWidth - space;
      }
      if (top < space) {
        top = space;
      }
      if (top > window.innerHeight - itemHeight - space) {
        top = window.innerHeight - itemHeight - space;
      }
      setLeft(left);
      setTop(top);
    }
  }
  function hanldeTouchEnd() {
    document.body.style.overflow = '';
  }

  // shake-animation 抖动动画
  return (
    <div
      className="bg-color-white d-shadow pos-f d-flex-c ai-center jc-center border-radius-40 z-300"
      ref={divRef}
      style={{
        width: `${itemWidth}px`,
        height: `${itemHeight}px`,
        left: `${left}px`,
        top: `${top}px`,
      }}
      onTouchStart={(e) => handleDragStart()}
      onTouchMove={(e) => handleTouchMove(e)}
      onTouchEnd={(e) => hanldeTouchEnd()}
    >
      <div className="d-flex-c mt-5 text-color-p ai-center" onClick={handleClick}>
        <img className="icon-20" src="/pic/icon_customer.png" alt="" />
        <span className="font-size-12 text-color-primary w-14">在线客服</span>
      </div>
    </div>
  );
}
